export class CompanySettingFormModel {
    companySurrKey: number;
    companyName: string;
    formTypeName: string;
    formTypeSurrKey: number;
    formLanguageData: Array<SettingFormByLanguageModel>;
}
export class SettingFormByLanguageModel {
    formLanguage: number;
    formSurrKey: number;
    formCode: string;
    formName: string;
    formType: number;
}

export class UpdateCompanyFormBody {
    companySurrKey: number;
    userSurrKey: number;
    companyFormModels: Array<UpdateCompanyFormModel> = new Array<UpdateCompanyFormModel>();
}
export class UpdateCompanyFormModel {
    formType: number;
    formLanguage: number;
    formSurrKey: number;
}
